import React, {PureComponent} from "react"
import {ApolloQueryResult} from "apollo-client"
import {MutationProps} from "react-apollo"
import gql from "graphql-tag"
import {DataProxy} from "apollo-cache"
import moment from "moment"
import {omit} from "lodash"

import sentry from "@irati/utils/services/sentry"
import {Mutation} from "@irati/utils/services/apollo"

import {Poll, PollList, PollInput} from "@irati/types"
import {openPollsQuery} from "../../query/OpenPolls"
import {TEAMS} from "../../../constants/share"
import {addPoll} from "../../helpers/polls"
import PollFragment from "../../fragments/Poll"

const graphQLMutation = gql`
  mutation createPoll($poll: PollInput!) {
    createPoll(poll: $poll) {
      ...Poll
    }
  }
  ${PollFragment}
`

interface Props extends Partial<MutationProps> {
  poll: PollInput
  children: any
}

interface Data {
  data: {
    createPoll: Poll
  }
}

interface CacheResult {
  polls: PollList
}

function parse(poll: PollInput) {
  const clone: any = {...poll}
  clone.trophy = omit(poll.trophy, "uuid")
  clone.teamIds = poll.teams.slice()
  clone.endsAt = moment(poll.endsAt).format()
  return omit(clone, TEAMS)
}

export default class CreatePollMutation extends PureComponent<Props> {
  render() {
    const {poll, children, ...props} = this.props
    return (
      <Mutation mutation={graphQLMutation} {...props}>
        {(mutate: any, apolloState: ApolloQueryResult<Data>) =>
          children(
            () =>
              mutate({
                variables: {
                  poll: parse(poll)
                },
                update: (cache: DataProxy, {data: {createPoll}}: Data) => {
                  try {
                    const result: CacheResult | null = cache.readQuery(openPollsQuery)

                    if (result) {
                      const {polls} = result
                      const newPolls = addPoll(polls, createPoll)

                      cache.writeQuery({
                        ...openPollsQuery,
                        data: {
                          polls: newPolls
                        }
                      })
                    }
                  } catch (e) {
                    sentry.captureException(e)
                  }
                }
              }),
            apolloState
          )
        }
      </Mutation>
    )
  }
}
